import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from 'react-router';
import Icons from '../../../../../common/widgets/Icons';
import Loader from '../../../../../common/widgets/Loader';
import { resources } from '../../../resources/resources';
import { cardService } from '../../../services/card';
import { EmptyStateDashboardMyCards } from '../../Common/EmptyStates';
import SingleCardDisplay from './SingleCardDisplay';
import StackedCardsCarusel from './StackedCardsCarousel';
interface CardsCarouselState {
  isLoading: boolean;
  cardsCoverUrls: string[];
}

export const MyCards = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  const [state, setState] = useState<CardsCarouselState>({
    isLoading: true,
    cardsCoverUrls: [] as string[],
  });

  const getCardsComponent = () => {
    if (state.cardsCoverUrls.length > 1) {
      return <StackedCardsCarusel cardsCoverUrls={state.cardsCoverUrls} />;
    } else if (state.cardsCoverUrls.length === 1) {
      return <SingleCardDisplay cardCoverUrl={state.cardsCoverUrls[0]} />;
    } else if (state.cardsCoverUrls.length === 0) {
      return <EmptyStateDashboardMyCards />;
    }
  };

  const loadCards = async (controller: AbortController) => {
    const response = await cardService.getCards({
      signal: controller?.signal,
    });

    if (controller.signal.aborted) return;

    if (!response.hasErrors) {
      setState(
        produce(draft => {
          draft.cardsCoverUrls = response.data.cards.map(c => {
            return c.mainImage ?? '';
          });
        }),
      );
    }

    setState(
      produce(draft => {
        draft.isLoading = false;
      }),
    );
  };

  useEffect(() => {
    const controller = new AbortController();

    loadCards(controller);

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="panel padding-xl">
      <div className="mydash-panel-header">
        <h2 className="mydash-title">{translate(resources.cards)}</h2>
        <button
          className="btn-link"
          onClick={() => navigate('/my-account/cards')}
        >
          <span className="btn-icon">
            <Icons.ArrowButton />
          </span>
          <span className="btn-text">
            {translate(resources.accountDashboard.myCardsAction)}
          </span>
        </button>
      </div>
      <div className="mydash-panel-content mydash-cards">
        <div className="edn-carousel edn-carousel-arrows arrows-outside">
          <Loader loading={state.isLoading} loader={<Skeleton />}>
            {getCardsComponent()}
          </Loader>
        </div>
      </div>
    </div>
  );
};
